'use client';
import { useLocale } from "next-intl";
import Image from "next/image";
import HeroButtonDialog from "@/components/home-page/HeroButton";
import { useTranslations } from "next-intl";
import React, { useEffect } from 'react';


export default function Offer() {
  const t = useTranslations('tophero');
  const te = useTranslations('Hero');
  const l = useLocale();

  function imagesbook() {
    return l == "ar" ? "/cover/بادل-أتقن-اللعبة.avif" :
      (l == "de" ? "/cover/padel-beherrsche-das-spiel.avif" :
        (l == "es" ? "/cover/padel-domina-el-juego.avif" :
          (l == "fr" ? "/cover/padel-maitrise-le-jeu.avif" :
            (l == "it" ? "/cover/padel-padroneggia-il-gioco.avif" :
              (l == "nl" ? "/cover/padel-beheers-het-spel.avif" :
                (l == "pt" ? "/cover/padel-domine-o-jogo.avif" :
                  (l == "ru" ? "/cover/падел-овладей-игрой.avif" :
                    (l == "sv" ? "/cover/padel-bemastra-spelet.avif" :
                      "/cover/padel-master-the-game.avif"
                    )
                  )
                )
              )
            )
          )
        )
      );
  }

  return (
    <>
     

           <div className="grid grid-cols-1 lg:grid-cols-5 gap-2 bg-bl px-4 lg:px-16 py-6">
        <div className="lg:col-span-3 flex justify-center items-center">
          <div>
            <h2 className="text-xl md:text-3xl lg:text-4xl  font-bold text-yel">
              {te('title')}
            </h2>
            <p className="text-white text-xl mt-1 font-bold">
              <span className="text-secondary bg-yel  px-2 font-bold">{te('Hurry')}</span> {te('t1')}
            </p>
            <p className="text-white mt-4 font-bold">
              {te('t3')}{" "}
              <span className="text-secondary bg-yel py-1 px-2 font-bold">{te('valued')}</span>
            </p>
            <p className="text-white text-sm sm:text-base font-bold">
              {te('t4')}
            </p>
          </div>
        </div>
        <div>
          <div className="h-60 w-auto relative">
            <Image
              src={imagesbook()}
              alt={te('padel-book-alt')}
              quality={85}
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 20vw"
              style={{ objectFit: "contain" }}
              priority
            />
          </div>
        </div>
        <div className="flex justify-center items-center">
          <HeroButtonDialog />
        </div>
      </div>
    </>
  );
}